export * from './Switch';
//# sourceMappingURL=index.js.map